<template>
  <div class="d-block">
    <div class="d-flex flex-sm-row flex-column justify-space-between pa-4 pa-md-6"
      :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : 'align-start'" style="gap: 1.5rem">
      <div class="d-flex flex-sm-row flex-column align-center"
        :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : 'align-start'" style="gap: 1.5rem">
        <v-avatar class="blue" rounded size="40">
          <v-icon dark> mdi-stairs-down </v-icon>
        </v-avatar>

        <div class="d-flex flex-column">
          <small class="grey--text">TOTAL</small>
          <span class="font-weight-bold">
            {{ `Php ${money_format(parseFloat(total_commission))}` }}
          </span>
        </div>

        <div class="d-flex flex-column">
          <small class="grey--text">SELECTED</small>
          <span class="font-weight-bold">
            {{ `Php ${money_format(parseFloat(total_selected))}` }}
          </span>
        </div>

        <!-- <h3 class="d-flex align-center pa-0" style="gap: 1.5rem">
          <v-avatar class="blue" rounded size="40">
            <v-icon dark> mdi-stairs-down </v-icon>
          </v-avatar>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="font-weight-bold">
                {{ `Php ${money_format(parseFloat(total_commission))}` }}
              </span>
            </template>
            <span>Your downline commission total amount</span>
          </v-tooltip>
        </h3> -->
      </div>

      <div class="d-inline-flex align-center ms-auto" style="gap: 1rem">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="doGetMyDownlineCommission">
              <v-icon>
                mdi-cached
              </v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>

        <v-text-field v-model="search" label="Search" single-line outlined dense clearable
          :disabled="!records.length || records_loading" autofocus placeholder="Search" hide-details="auto" />

        <v-btn icon @click="set_filter_dialog">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </div>
    </div>

    <v-divider></v-divider>

    <v-data-table v-model="selected" :headers="headers" :items="records" :items-per-page="5" :loading="records_loading"
      :hide-default-footer="records.length <= 5 ? true : false" loading-text="Loading, Please wait" :search="search"
      item-key="id" show-select>
      <template v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:[`item.amount`]="{ item }">
        <span class="font-weight-bold">
          {{ `Php ${money_format(parseFloat(item.amount))}` }}
        </span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip small style="line-height: 0.8; padding: 4px 10px !important"
          :class="item.status == 'Settled' ? 'green lighten-5 green--text' : 'orange lighten-5 orange--text'">
          {{ item.status }}
        </v-chip>
      </template>

      <template v-slot:[`item.requested_at`]="{ item }">
        <span class="text-uppercase">
          {{ date_format(item.requested_at) }}
        </span>
      </template>
    </v-data-table>
    <div v-if="records && records.length != 0">
      <v-divider></v-divider>
      <div class="d-flex justify-end pa-4 pa-md-6">
        <v-btn :disabled="selected.length == 0" class="primary" depressed @click="confirmation_dialog = true">
          Approve
        </v-btn>
      </div>
    </div>

    <DateFilter v-if="filter_dialog" :dates="dates" @set_close_date_filter_dialog="set_close_date_filter_dialog" />
    <MyDownlineCommissionConfirmation v-if="confirmation_dialog" :records="selected"
      @set_close_confirmation_dialog="set_close_confirmation_dialog" />
  </div>
</template>

<script>
import responseGet from '@/helpers/api_request_get'
import formatDate from "@/helpers/formatDatev2"
import DateFilter from '@/components/app/approve_commissions/tab_items/DateFilter'
import MyDownlineCommissionConfirmation from './MyDownlineCommissionConfirmation.vue';

export default {
  components: { DateFilter, MyDownlineCommissionConfirmation },

  data: () => ({
    records: [],
    records_loading: false,
    search: '',
    selected: [],
    dates: {},
    filter_dialog: false,
    date_from: null,
    date_to: null,
    confirmation_dialog: false,
    headers: [
      { text: "Requested By", value: "name", class: "text-uppercase" },
      { text: "Type", value: "type", class: "text-uppercase" },
      {
        text: "Commission Amount",
        value: "amount",
        class: "text-uppercase",
        align: "right",
      },
      { text: "Date Requested", value: "requested_at", class: "text-uppercase" },
    ],
  }),

  computed: {
    total_commission() {
      if (this.records) {
        const sum = this.records.reduce(
          (acc, curr) => acc + parseFloat(curr.amount), 0
        );

        return sum;
      }

      return 0;
    },

    total_selected() {
      if (this.selected) {
        const sum = this.selected.reduce(
          (acc, curr) => acc + parseFloat(curr.amount), 0
        );

        return sum;
      }

      return 0;
    },
  },

  mounted() {
    this.doGetMyDownlineCommission()
  },

  methods: {
    async doGetMyDownlineCommission() {
      this.records = []
      this.records_loading = true;

      const form_data = new FormData();

      form_data.append("date_from", (this.date_from) ?? '');
      form_data.append("date_to", (this.date_to) ?? (this.date_from) ?? '');

      const res = await responseGet(new URLSearchParams(form_data), "commissions/commission_downline");

      switch (res.status) {
        case 200:
          this.records = res.data.requested;
          this.$emit("update_my_downline_commission_badge", this.records.length)
          break;
        case 401:
          setTimeout(() => {
            localStorage.removeItem("userToken");
            this.$router.push({ name: "Home" });
            location.reload();
          }, 3000);
          break;
      }

      this.records_loading = false;
    },

    set_filter_dialog() {
      this.dates = {
        'date_from': this.date_from,
        'date_to': this.date_to
      }

      this.filter_dialog = true
    },

    set_close_date_filter_dialog(data) {
      if (Object.keys(data).length) {
        this.date_from = data.date_from
        this.date_to = data.date_to

        this.doGetMyDownlineCommission()
      }

      this.filter_dialog = !this.filter_dialog
    },

    set_close_confirmation_dialog(status) {
      if (status) {
        this.selected = []
        this.doGetMyDownlineCommission()
      }

      this.confirmation_dialog = !this.confirmation_dialog
    },

    money_format(val) {
      return val.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    date_format(date) {
      return formatDate(date, "datetime");
    },
  }
}
</script>